import React from "react";

const Card = ({ icon, children }) => {
    return (
        <div className="flex flex-col items-center text-center space-y-4">
            <div className="text-5xl">{icon}</div>
            <div>{children}</div>
        </div>
    );
};

export default Card;
